module.exports = __webpack_public_path__ + "img/lscl1.40e8f8a2.jpg";